import React from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import { SERVER_URL } from "../../constants/global";
import Link from "@mui/material/Link";
import { Link as RouterLink } from "react-router-dom";
import { routeConfigs } from "../../navigation/routeConfig";

interface OtherDetailsProps {
  data: any;
}

const PharmacyBusinessInformation: React.FunctionComponent<OtherDetailsProps> = ({
  data,
}) => {
  const irsDefaultFile = data.PharmacyFiles?.find((file: any) => file.File.type === 'irs147CLetter');

  return (
    <Box>
      <Typography id="business-information-section" component="h1" variant="h5" sx={{ mb: 3 }}>
        Business Information
      </Typography>
      <Grid container spacing={2}>
        {irsDefaultFile?.File?.key ? (
          <Grid item xs={12}>
            <Link href={`${SERVER_URL}/file/${irsDefaultFile.File.key}`} color="inherit" target='_blank'>
              147c (confirmation letter from IRS)
            </Link>
          </Grid>
        ) : null}
        <Grid item xs={12}>
          <Divider sx={{ borderWidth: '1px', mb: 1, mt: 1 }} />
        </Grid>
        <Grid item xs={12}>
          <Box
            sx={{
              p: 2,
              border: '1px solid rgba(0, 0, 0, 0.12)',
              borderRadius: 2,
              bgcolor: 'rgba(76, 175, 80, 0.06)',
            }}
          >
            <Typography sx={{ fontWeight: 600, mb: 1 }}>Note</Typography>
            <Typography sx={{ fontSize: 14, lineHeight: 1.5 }}>
              Payout bank accounts are managed in{" "}
              <Link component={RouterLink} to={routeConfigs.bankAccount.path} underline="hover">
                Bank info
              </Link>
              , under Payout Method.
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default PharmacyBusinessInformation;
